import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetEnvNames } from '@/api/sys.user';
import util from '@/libs/util';
export default {
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var users, host, index;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('moreUser', _this.moreUser);

              if (_this.moreUser) {
                users = process.env.VUE_APP_API_USERS.split(',');
                _this.userOptions = users.map(function (v) {
                  var obj = {};
                  obj.value = v;
                  obj.label = v;
                  return obj;
                });
                host = location.hostname;
                index = users.findIndex(function (v) {
                  return v.includes(host);
                });

                if (!util.cookies.get('userApi')) {
                  if (index !== -1) {
                    _this.user = users[index];
                    util.cookies.set('userApi', users[index]);
                  } else {
                    _this.user = util.cookies.get('userApi');
                  }
                } else {
                  _this.user = util.cookies.get('userApi');
                }
              } // console.log(this.userOptions)
              // this.host = util.cookies.get('apiName')
              // let res = await GetEnvNames()
              // if (res.Result) {
              //   this.options = res.Result.map(v => {
              //     let obj = {}
              //     obj.value = v
              //     obj.label = v
              //     return obj
              //   })
              //   if (!util.cookies.get('apiName')) {
              //     util.cookies.set('apiName', res.Result[0])
              //   } else {
              //     let apiname = util.cookies.get('apiName')
              //     if (!res.Result.includes(apiname)) {
              //       util.cookies.set('apiName', res.Result[0])
              //     }
              //   }
              //   this.host = util.cookies.get('apiName')
              // }
              // console.log(res)


            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  data: function data() {
    return {
      drawer: false,
      hostForm: {
        VUE_APP_API_USER: null,
        VUE_APP_API: null,
        VUE_APP_API_JOB: null,
        VUE_APP_PRINT_TPL: null
      },
      host: null,
      options: [],
      userOptions: [],
      user: '',
      moreUser: process.env.VUE_APP_MORE_API_USER === 'ON'
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      // util.cookies.set('apiName', this.host)
      // this.$message.success('切换环境成功')
      util.cookies.set('userApi', this.user);
      window.location.reload(); // this.$message.success('切换用户中心成功')
      // this.drawer = false
    },
    handleCancel: function handleCancel() {
      this.drawer = false;
    },
    handleToggle: function handleToggle() {
      this.drawer = true;
    },
    handleClose: function handleClose(done) {
      done();
    }
  }
};